import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Un fichier JSON par langue et par namespace : src/locales/<langue>/<namespace>.json (voir docs/i18n.md)
const files = import.meta.glob<Record<string, unknown>>("./locales/*/*.json", {
  eager: true,
  import: "default",
});

const resources: Record<string, Record<string, Record<string, unknown>>> = {};
for (const [path, content] of Object.entries(files)) {
  const [, lng, ns] = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/) ?? [];
  if (!lng || !ns) continue;
  resources[lng] = { ...resources[lng], [ns]: content };
}

export const SOURCE_LANGUAGE = "fr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: Object.keys(resources[SOURCE_LANGUAGE]),
    defaultNS: "common",
    keySeparator: false, // clés plates : "bloc.element" est une seule clé (voir docs/i18n.md)
    supportedLngs: ["fr", "en"],
    fallbackLng: SOURCE_LANGUAGE,
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
  });

export default i18n;
